import React from 'react';
import styles from './DataGrid.module.css';
import LinkIcon from '../link-icon/LinkIcon';
import { CHECK_ICON, DELETE_ICON, EDIT_ICON } from '../../utils/consts';
import { convertNumericToJaNein } from '../../utils/convert-data';

const DataGrid = ({ data, config, keyExtractor }) => {
	return (
		<div className='table-responsive'>
			<table className={`table table-bordered ${styles.striped_table}`}>
				<thead className={styles.tableHeader}>
					<tr>
						{config.columns.map((column) => (
							<th key={column.key}>{column.label}</th>
						))}
						<th>Aktion</th>
					</tr>
				</thead>
				<tbody>
					{data.map((item) => {
						const key = keyExtractor ? keyExtractor(item) : item.id;
						return (
							<tr key={key}>
								{config.columns.map((column) => (
									<td key={column.key}>
										{convertNumericToJaNein(item[column.key])}
									</td>
								))}
								{/* Action */}
								<td className='d-flex gap-3 justify-content-center'>
									<LinkIcon
										route={config.route + '/' + key}
										icon={EDIT_ICON}
										classes={'background-blue'}
									/>
									{config.has_check_action && (
										<LinkIcon
											route={config.check_route + '/' + key}
											icon={CHECK_ICON}
											classes={'background-green'}
										/>
									)}
									<LinkIcon
										route={config.route + '/' + key}
										icon={DELETE_ICON}
										classes={'background-red'}
									/>
								</td>
							</tr>
						);
					})}
				</tbody>
			</table>
		</div>
	);
};

export default DataGrid;
